(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatch-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSwatchTabs(root) {
      if (root.dataset.swatchTabsBound === 'true') return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.swatch-tab'));
      if (!tabs.length) return;
      root.dataset.swatchTabsBound = 'true';

      var panels = Array.prototype.slice.call(root.querySelectorAll('.swatch-panel'));

      function activate(name) {
        tabs.forEach(function (t) {
          var on = t.dataset.tab === name;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.panel === name);
        });
      }

      // A link can open a specific tab via the configured query param, e.g.
      // /products/x?tab=sets. Falls back to the server-rendered default.
      var param = root.dataset.tabParam || 'tab';
      var requested = null;
      try {
        requested = new URLSearchParams(window.location.search).get(param);
      } catch (e) {}
      if (requested && tabs.some(function (t) { return t.dataset.tab === requested; })) {
        activate(requested);
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { activate(t.dataset.tab); });
      });
    }

    function initSwatchRails(root) {
      Array.prototype.forEach.call(root.querySelectorAll('.swatch-rail'), function (rail) {
        if (rail.dataset.railBound === 'true') return;
        rail.dataset.railBound = 'true';
        var scroller = rail.querySelector('[data-rail-scroller]');
        var prev = rail.querySelector('[data-rail-prev]');
        var next = rail.querySelector('[data-rail-next]');
        if (!scroller || !prev || !next) return;

        function update() {
          var overflow = scroller.scrollWidth - scroller.clientWidth > 1;
          prev.hidden = !overflow;
          next.hidden = !overflow;
          if (!overflow) return;
          prev.disabled = scroller.scrollLeft <= 1;
          next.disabled = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1;
        }

        function step(dir) {
          scroller.scrollBy({ left: dir * scroller.clientWidth * 0.8, behavior: 'smooth' });
        }

        prev.addEventListener('click', function () { step(-1); });
        next.addEventListener('click', function () { step(1); });
        scroller.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        // Re-measure when the panel is shown or the column resizes
        if (window.ResizeObserver) new ResizeObserver(update).observe(scroller);
        update();
      });
    }

    function initAll() {
      document.querySelectorAll('[data-swatch-selector][data-tabbed="true"]').forEach(initSwatchTabs);
      document.querySelectorAll('[data-swatch-selector]').forEach(initSwatchRails);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    // Re-bind when the block is re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
